import { toSafeObject } from '../utils/toSafeObject.js';
import { toSafeString } from '../utils/toSafeString.js';

/* The words after "Completed with failures · ": which step failed and how often, counted against the items its loop
   ran — "2 of 3 Send reminder email". Shared so the run logs, the rail and the owner's email give the same count.
   Reads only C1 fields (workflowRunSummary.failures and .loops). */
const describePieveWorkflowRunFailures = ({ failures, loops } = {}) => {
  const safeFailures = Array.isArray(failures) ? failures : [];

  if (safeFailures.length < 1) {
    return null;
  }

  const stepIds = [...new Set(safeFailures.map((failure) => toSafeString(failure?.stepId)))];

  if (stepIds.length > 1) {
    return `${safeFailures.length} failures in ${stepIds.length} steps`;
  }

  const first = safeFailures[0];
  const stepName = toSafeString(first?.stepName) || toSafeString(first?.stepId) || 'A step';
  const loopTotal = Number(toSafeObject(toSafeObject(loops)[toSafeString(first?.loopStepId)]).total);

  if (Number.isFinite(loopTotal) && loopTotal > 0) {
    return `${safeFailures.length} of ${loopTotal} ${stepName}`;
  }

  return safeFailures.length === 1 ? stepName : `${safeFailures.length} × ${stepName}`;
};

export default describePieveWorkflowRunFailures;
